<template>
  <div
    v-intersect="{
      handler: onIntersect,
      options: {
        threshold: 0.8,
      },
    }"
  >
    <!-- <slot v-bind="$attrs"></slot> -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["id"],

  data() {
    return {
      isIntersecting: false,
      isReported: false,
      timer: null,
      stIntersect: new Date(),

      minDuration: 500,
      maxDuration: 10000,
      totalDuration: 0,
    }
  },

  methods: {
    onIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting

      /*
      // If already reported, return
      if (this.isReported) {
        return
      }
      */

      this.clearEndlessTimer()

      if (this.isIntersecting) {
        // When intersect, start the timer
        this.startEndlessTimer()
      }
    },

    startEndlessTimer() {
      // If the timer is already set, or the total duration is more than the max duration, return
      if (this.timer || this.totalDuration > this.maxDuration) {
        return
      }

      // Set the start time of intersect
      this.stIntersect = new Date()

      // Keep emitting the event until it reaches the max duration
      this.timer = setTimeout(() => {
        this.emitIntersect()
        this.clearEndlessTimer()
        this.startEndlessTimer()
      }, this.minDuration)
    },

    clearEndlessTimer() {
      // Clear the timer
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },

    // Emit Intersect
    emitIntersect() {
      // Calculate the interval, and emit the event
      const interval = new Date() - this.stIntersect
      // if (interval < this.minDuration) {
      //   return
      // }
      // if (interval > this.maxDuration) {
      //   interval = this.maxDuration
      // }

      this.$emit("intersect", this.id, interval)
      this.totalDuration += interval

      // Reset start time
      this.stIntersect = new Date()
    },
  },
}
</script>
